import PropTypes from 'prop-types';
import buyCertificationLink from '@/domain/buyCertificationLink';

export default function CertificationBuyLink({ productId }) {
  return (
    <a
      className="flex w-full items-center justify-center space-x-2 rounded-full border border-transparent bg-green-500 px-4 py-2 text-center font-semibold leading-5 text-white ring-transparent hover:bg-green-600 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:text-lg"
      href={buyCertificationLink(productId)}
    >
      Comprar certificación
    </a>
  );
}

CertificationBuyLink.defaultProps = {};

CertificationBuyLink.propTypes = {
  productId: PropTypes.number.isRequired,
};
